/**
 * Estilo de interface (28/10, N5): a regra de qual estilo vale para uma pessoa, uma só para a API (sessão) e para o web.
 * Precedência: fixado pelo administrador > escolha da pessoa (se o administrador permitir) > padrão do workspace > Maré Malgo (padrão desde 03/11).
 * `null` na escolha da pessoa significa "seguir o padrão do workspace".
 */
export const ESTILOS_INTERFACE = ['mare_malgo', 'gelo', 'malgo', 'proprio', 'cupertino', 'mare', 'redmond', 'mountain_view', 'armonk', 'embarcadero', 'sydney', 'grafite', 'ottawa'] as const;
export type EstiloInterface = (typeof ESTILOS_INTERFACE)[number];
export const ESTILO_INTERFACE_PADRAO: EstiloInterface = 'mare_malgo';

/** "Malgo" ou "MalgoOS" no nome exibido é a própria marca do produto, não a de um cliente: vale a assinatura oficial. Tela e e-mail. */
export const nomeEhDoProduto = (nome: string | null | undefined) => !nome?.trim() || /^malgo ?(os)?$/i.test(nome.trim());

export const ehEstiloInterface = (v: unknown): v is EstiloInterface => typeof v === 'string' && (ESTILOS_INTERFACE as readonly string[]).includes(v);

export interface EntradaEstiloEfetivo {
  /** `workspace_membros.estilo_fixado`: o administrador fixou este estilo para a pessoa. */
  fixado?: string | null;
  /** `usuarios.estilo`: a escolha da pessoa (null = seguir o padrão do workspace). */
  pessoa?: string | null;
  /** `aparencia.permitir_estilo_pessoal` (ausente = permitido). */
  permitirPessoal?: boolean;
  /** `aparencia.estilo_padrao` (ausente = Maré Malgo). */
  padrao?: string | null;
}

export function estiloEfetivo(e: EntradaEstiloEfetivo): EstiloInterface {
  if (ehEstiloInterface(e.fixado)) return e.fixado;
  if (e.permitirPessoal !== false && ehEstiloInterface(e.pessoa)) return e.pessoa;
  if (ehEstiloInterface(e.padrao)) return e.padrao;
  return ESTILO_INTERFACE_PADRAO;
}
